import styles from './style.postcss';

import React, { Component } from 'react';
import invariant from 'invariant';
import is from 'is_js';
import { Form, testClass, Store } from 'omni-common-ui';
import PropTypes from 'prop-types';

import {
  TableViewTr,
} from 'components/TableView';
import SwitchButton from 'components/SwitchButton';
import { actions as groupActions } from 'containers/Group';

import AveragesOverviewTable from './AveragesOverviewTable';
import SkillsAveragesTable from './SkillsAveragesTable';
import RewardsTable from './RewardsTable';

const TABLES = {
  'Averages Overview': AveragesOverviewTable,
  'Skills Averages': SkillsAveragesTable,
};

class PerformanceCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTable: 'Averages Overview',
    };
  }

  render() {
    const { groupId, groupPerformance, disableSwitchTable } = this.props;
    if (! is.existy(groupPerformance) || ! is.existy(groupPerformance.studentsPerformance)) {
      return null;
    }

    const state = Store.get().getState();

    if (groupActions.isHFCourseTypeGroup(state, groupId) &&
        groupActions.hasContentPath(state, groupId)) {
      Object.assign(TABLES, { Rewards: RewardsTable });
    }

    const isAnyStudentHasRewards =
        groupPerformance.studentsPerformance.some((studentPerformance) =>
          is.existy(studentPerformance.rewards));
    const isAnyStudentHasTotalScore =
        groupPerformance.studentsPerformance.some((studentPerformance) =>
          is.number(studentPerformance.averageTotalScore) &&
          studentPerformance.averageTotalScore > 0);
    const isAnyStudentHasHomeworkCompletion =
        groupPerformance.studentsPerformance.some((studentPerformance) =>
          is.number(studentPerformance.averageOnlineHomeworkCompletion) &&
          studentPerformance.averageOnlineHomeworkCompletion > 0);
    const isAnyStudentHasPaperBasedHomeworkCompletion =
        groupPerformance.studentsPerformance.some((studentPerformance) =>
          is.number(studentPerformance.averagePaperBasedHomeworkCompletion) &&
          studentPerformance.averagePaperBasedHomeworkCompletion > 0);
    const isPerformanceCardShown = isAnyStudentHasHomeworkCompletion ||
        isAnyStudentHasTotalScore ||
        isAnyStudentHasPaperBasedHomeworkCompletion;
    if (! isPerformanceCardShown) {
      return null;
    }
    const options = Object.keys(TABLES).map((name, idx) => {
      if (name === 'Rewards') {
        return { label: name, value: name, disabled: idx > 0 && ! isAnyStudentHasRewards };
      }

      return { label: name, value: name, disabled: idx > 0 && ! isAnyStudentHasTotalScore };
    });
    // eek. why does TableView have a PageCard in it?
    const OriginalCmpt = TABLES[this.state.activeTable];
    const that = this;
    const EnhancedCmpt = class extends OriginalCmpt {
      _renderTableHeaderRow(arg) {  // override
        const secondRow = super._renderTableHeaderRow(arg);
        invariant(secondRow && secondRow.props && secondRow.props.children,
            'it should have an existing heading row with children');
        const headingsCount = React.Children.count(secondRow.props.children);
        const firstRow = <TableViewTr key="PerformanceCard-hrow1">
          <td colSpan={headingsCount}>
            <div className={styles.PerformanceCard_firstHeaderRow}>
              <Form className={styles.PerformanceCard_form}>
                <Form.Select className={styles.PerformanceCard_select}
                    name="table"
                    options={options}
                    value={that.state.activeTable}
                    setValue={(val) => {
                      that.setState({ activeTable: val });
                    }}
                    clearable={false}
                    searchable={false} />
              </Form>
              {
                that.state.activeTable === 'Rewards' &&
                <SwitchButton text="Percent"
                    isSelected={this.state.isShowPercent}
                    onSwitchButtonClicked={this._onSwitchButtonClicked} />
              }
            </div>
          </td>
        </TableViewTr>;
        return disableSwitchTable ? [secondRow] : [firstRow, secondRow];
      }
    };
    EnhancedCmpt.displayName = this.state.activeTable;
    return <div className={testClass('performance-card')}>
      <EnhancedCmpt {...this.props} />
    </div>;
  }
}

PerformanceCard.propTypes = {
  groupId: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  groupPerformance: PropTypes.object.isRequired,
  disableSwitchTable: PropTypes.bool,
  sessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PerformanceCard;



// WEBPACK FOOTER //
// ./containers/Group/Dashboard/PerformanceCard/index.jsx